<div class="content" *ngIf="src && playerId" oncontextmenu="return false;">
    <video [id]="playerId" class="video-js vjs-big-play-centered" controls>
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
        </p>
    </video>
</div>

<div class="container" *ngIf="validateUrl(externalMediaUrl) && !src" fxLayoutAlign="center center">
    <app-iframe-maximizer fxFlex [src]="externalMediaUrl | safe" class="responsive-iframe"></app-iframe-maximizer>
</div>

<!--<pre>{{ vhs_stats | json }}</pre>-->
